import {Button} from 'antd'
import {useFilterByLicense} from '@/biz/license.jsx'
import runAsync from '@/script/runAsync.mjs'
import {useMapContext} from '@/components/MindMap/index.mjs'

export default function PropertiesPaneButtonLintCode(props) {
    const filterByLicense = useFilterByLicense()
    const map = useMapContext()
    const nodes = [...map.useSelectedNodes()]

    if (1 !== nodes.length) {
        return null
    }

    const [node] = nodes
    const {prjId, ssCode, sVer} = node.data

    const handleClick = () => runAsync(
        () => map.syntax.batchCheck({prjId, ssCode, sVer}),
        {action: '规范性检测'}
    )

    return filterByLicense('M00040003',
        <Button
            disabled={! (prjId && ssCode && sVer)}
            onClick={handleClick}
            {...props}
        >
            规范性检测
        </Button>
    )
}
